mutation cancelGrant($caseRecordId: ID!, $reason: String!) {
  cancelGrant(input: { caseRecordId: $caseRecordId, reason: $reason }) {
    grantCaseRecord {
      id
    }
  }
}
